import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import Publication from "component/shared/publication/Publication";
import { useIntl } from "react-intl";
// import { useParams } from "react-router-dom";
import CustomizedSearchComponentWrapper from "./components/customized-search-component-wrapper";
import IndicatorSearchCard from "./components/indicator-search-card";
import InfographicSearchCard from "./components/infographic-search-card";
import NewsSearchCard from "./components/news-search-card";
import "./custoimizedSearchPage.scss";
import NewsTitleCard from "./components/news-title-card";

const CustomizedSearchPage = ({
  mainSubjectId = null,
  subSubjectId = null,
  subject = null,
  indicators = [],
  publications = [],
  news = [],
  infographics = [],
  renderInfoGraphics = false,
  disableIndicatorsLink = false,
  renderNewsTitleOnly = true,
}) => {
  const intl = useIntl();

  const RenderIndicators = () => {
    const rendering =
      indicators.length > 0 ? (
        <>
          <IndicatorSearchCard
            mainSubjectId={mainSubjectId}
            subjectId={subSubjectId}
            indicators={indicators}
          />
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };
  const RenderPublications = () => {
    const rendering =
      publications.length > 0 ? (
        <div
          style={{
            maxHeight: "520px", // Adjust the height as needed
            overflowY: "auto",
            //marginTop: "1rem", // Optional, adds spacing between the sections
          }}
        >
          {publications.map((item, index) => (
            <Publication key={index} item={item} subject={subject} />
          ))}
        </div>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };
  const RenderNews = () => {
    const rendering =
      news.length > 0 ? (
        renderNewsTitleOnly ? (
          <>
            {news.map(({ name, id, translations }, index) => (
              <div key={index}>
                <NewsTitleCard
                  name={name}
                  id={id}
                  translations={translations}
                />
              </div>
            ))}
          </>
        ) : (
          news.map(
            (
              { title, id, image, brief, publishDate, newsTranslation },
              index
            ) => (
              <div key={index}>
                <NewsSearchCard
                  title={title}
                  img={image}
                  brief={brief}
                  id={id}
                  date={publishDate}
                  translations={newsTranslation}
                />
              </div>
            )
          )
        )
      ) : (
        <DataNotFound />
      );
    return rendering;
  };
  const RenderInfoGraphics = () => {
    const rendering =
      infographics.length > 0 ? (
        <>
          <InfographicSearchCard infographics={infographics} />
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };
  return (
    <div className="customized-search-page">
      <div className="container">
        {indicators.length > 0 && (
          <CustomizedSearchComponentWrapper
            title={intl.formatMessage({ id: "data" })}
            buttonText="data"
            link={
              disableIndicatorsLink
                ? null
                : `data/mainSubject/${mainSubjectId}/subSubject/${subSubjectId}`
            }
          >
            <RenderIndicators />
          </CustomizedSearchComponentWrapper>
        )}
        {publications.length > 0 && (
          <CustomizedSearchComponentWrapper
            title={intl.formatMessage({ id: "publications" })}
            link={publications.length > 0 ? "publications" : null}
            buttonText="publications"
          >
            <RenderPublications />
          </CustomizedSearchComponentWrapper>
        )}
        <CustomizedSearchComponentWrapper
          display={renderInfoGraphics}
          title={intl.formatMessage({ id: "infographic" })}
        >
          <RenderInfoGraphics />
        </CustomizedSearchComponentWrapper>
        {news.length > 0 && (
          <CustomizedSearchComponentWrapper
            title={intl.formatMessage({ id: "news" })}
            buttonText="all-news"
            link={news.length > 0 ? "mediaLanding/news" : null}
          >
            <RenderNews />
          </CustomizedSearchComponentWrapper>
        )}
      </div>
    </div>
  );
};
export default CustomizedSearchPage;
